import React from 'react';

// PiP 창 안에 그려지는 패널. 별도 창이라 antd/CSS를 가져오지 않고 인라인 스타일만 쓴다.
// 위쪽에 [조합 캡처] [게임 시작] 버튼, 아래(children)에 조합 분석(전체 팀 요약 / 팀 상세)을 보여준다.

const baseButton = {
  flex: 1,
  height: 40,
  border: 'none',
  borderRadius: 6,
  color: '#fff',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  fontFamily: 'inherit',
};

export default function PipPanel({
  onCaptureComp, onStartGame, notice, busy, phaseLabel = null, maximized = false, onToggleMaximize = null, side = null, children,
}) {
  return (
    <div
      style={{
        boxSizing: 'border-box',
        height: '100vh',
        padding: 8,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        background: '#1f1f2e',
        color: '#d9d9d9',
        fontFamily: "'Pretendard', 'Malgun Gothic', sans-serif",
      }}
    >
      <div style={{ display: 'flex', gap: 6 }}>
        <button
          type="button"
          style={{ ...baseButton, background: busy ? '#595959' : '#1677ff' }}
          onClick={onCaptureComp}
          disabled={busy}
        >
          조합 캡처
        </button>
        <button type="button" style={{ ...baseButton, background: '#389e0d' }} onClick={onStartGame}>
          게임 시작
        </button>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, lineHeight: '16px', minHeight: 16 }}>
        <div style={{ flex: 1, overflow: 'hidden' }}>{notice}</div>
        {phaseLabel && (
          <div style={{ flexShrink: 0, padding: '1px 8px', borderRadius: 10, background: '#2a2a3d', border: '1px solid #4a4a5d', fontWeight: 600 }}>
            지금 {phaseLabel}
          </div>
        )}
        {onToggleMaximize && (
          <button
            type="button"
            style={{ flexShrink: 0, padding: '1px 10px', borderRadius: 10, border: '1px solid #4a4a5d', background: '#2a2a3d', color: '#d9d9d9', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}
            onClick={onToggleMaximize}
            title={maximized ? '이전 크기로 되돌립니다' : '이 창이 있는 모니터에서 브라우저가 허용하는 가장 큰 크기(모니터의 80%)로 키웁니다'}
          >
            {maximized ? '복원' : '최대화'}
          </button>
        )}
      </div>
      {(children || side) && (
        // 좌: 팀 조합/파워 커브(children), 우: side(지도). 반반으로 나누고, 창이 좁으면 우측이 아래로 내려간다.
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', gap: 8 }}>
          {children && <div style={{ flex: '1 1 0', minWidth: 320 }}>{children}</div>}
          {side && <div style={{ flex: '1 1 0', minWidth: 320 }}>{side}</div>}
        </div>
      )}
    </div>
  );
}
